export function normalizeStringOrUndefined(value: string | null | undefined): string | undefined {
  return !value ? undefined : value.trim().toLowerCase();
}

export function getQualificationTrackingState(
  customerSegment: string | null,
  offerType: string | null | undefined,
): {
  offerTypeNormalized: string | undefined;
  advertiserType: string | undefined;
} {
  const isTenant = customerSegment === 'tenant';

  return {
    offerTypeNormalized: isTenant ? 'rent' : normalizeStringOrUndefined(offerType ?? undefined),
    advertiserType: isTenant ? 'tenant' : normalizeStringOrUndefined(customerSegment ?? undefined),
  };
}
